<template>
  <div class="sign">
    <div class="sign-title">
      <div
      v-for="item in stateList"
      :key="item.id"
      class="sign-title-state"
      :class="state===item.id?'active':''"
      @click="changeState(item)">{{item.name}}</div>
    </div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div v-for="(item,index) in signList"
          :key="index"
          class="flex sign-body"
        >
          <div class="sign-icon" :class="item.SignState===1?item.isSign?'active':'':''">
            <i class="iconfont">&#xe614;</i>
          </div>
          <div class="sign-text nowrap">
            <div class="sign-text-top nowrap">{{ item.SignFileName }}</div>
            <div class="sign-text-bottom nowrap">截止：{{item.EndTime}}</div>
          </div>
          <div>
            <div
            class="reads-btn"
            :class="item.SignState===1?item.isSign?'reads':'':''"
            @click="goSign(item)">{{item.SignState===1?item.isSign?'去签字':'已过期':'已签字'}}</div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
export default {
  name: 'Sign',
  data(){
    return {
      state:0,
      stateList: [
        {
          name: '不限',
          id: 0
        },
        {
          name: '未签字',
          id: 1
        },
        {
          name: '已签字',
          id: 2
        },
      ],
      list:[],
      loading: false,// 是否加载中
      finished: false,// 加载是否完成
      isLoading: false,//是否处于下拉刷新状态
      num:1,
      pageSize:15,
    }
  },
  computed:{
    childData(){
      return JSON.stringify(this.$store.state.parentInfo.childData)
    },
    signList(){
      let arrs = this.list
      for (let i = 0,len=arrs.length;i<len;i++) {
        let formats = 'YYYY-MM-DD HH:mm:ss'
        let endTime = this.xy.moment(arrs[i].EndTime,formats)
        let nowDate = this.xy.moment().format(formats)
        let isSigning = endTime.isAfter(nowDate)//结束时间>当前时间  返回true
        arrs[i].isSign = isSigning ? true : false
      }
      return arrs
    }
  },
  mounted(){

  },
  methods:{
    async onLoad() {
      if(this.childData.length>0){
        this.xy.loading()
        let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/SignFileDetailManage/GetChildSignFilePage`, {
          PageIndex: this.num,
          PageSize:this.pageSize,
          SignState: this.state,
          StartTime: '',
          EndTime: '',
          StudentID: JSON.parse(this.childData).ChildrenID
        });
        if (res.success) {
          let _list = [],obj={isSign:true};
          res.data.data.map(item => {
            Object.assign(item, obj)
          })
          _list = res.data.data
          this.list = [...this.list, ..._list]
          this.loading = false
          this.num++
          this.finished = (this.list.length>=res.data.totalRecords) ? true : false
        }
        this.xy.unloading()
      }

    },
    onRefresh() {
      setTimeout(() => {
        this.list = []
        this.num =1
        this.isLoading = false
        this.onLoad()
      }, 500)
    },
    changeState(val){
      this.state=val.id
      this.onRefresh()
    },
    goSign(val){
      this.$store.commit('parentInfo/addSignState',{
        SignFileID:val.SignFileID,
        SignState:val.SignState,
        SignFileDetailID:val.SignFileDetailID,
        isSign:val.isSign
      })
      this.$router.push('/homeSchool/SignDetails')
    }
  }
};
</script>
<style lang="less" scoped>
.sign-title{
  display: flex;
  height: 88px;
  align-items: center;
  background: #fff;
  padding: 0 30px;
  .sign-title-state{
    padding: 10px 30px;
    background: #F1F0F5;
    margin-right: 40px;
    border-radius: 32px;
    color: #999999;
    font-size: 26px;
  }
  .sign-title-state.active{
    color: #2E7BFD;
  }
}
.sign-body{
  margin: 0 30px 30px;
  height: 162px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  box-shadow: 0 4px 6px 0 rgba(187,187,187,0.2);
  margin-top: 26px;
  border-radius: 28px;
  padding: 20px;
  .sign-icon{
    width: 70px;
    height: 70px;
    line-height: 70px;
    text-align: center;
    border-radius: 8px;
    background: #ccc;
    color: #fff;
  }
  .sign-icon.active{
    background: #4196ff;
  }
  .sign-text{
    flex: 1;
    margin: 0 30px;
    .sign-text-top{
      font-size: 28px;
      color: #333;
      margin-bottom: 15px;
    }
    .sign-text-bottom{
      font-size: 24px;
      color: #999;
    }
  }
  .reads-btn{
    width: 140px;
    text-align: center;
    height: 52px;
    line-height: 52px;
    box-shadow: 0 2px 5px 0 rgba(179,178,182,0.5);
    border-radius: 26px;
    background: #F1F0F5;
    color: #999;
    font-size: 26px;
  }
  .reads-btn.reads{
    color: #2E7BFD;
  }
}
</style>
